<template>
  <div>
    <TempPopup />
    <div id="container" class="library_st_detail grid-container">
      <Sidebar />
      <Subbar class="sub_bar_custom" @sort="sortTable">
        <!-- 기본 서재 -->
      </Subbar>
      <div v-if="!isBookshelfLoading" class="section full">
        <div class="inner">
          <div class="eplist item_columns_grid">
            <BookTable ref="booktable" />
          </div>
        </div>
      </div>
    </div>
    <!-- ERROR MODAL START -->
    <transition name="modal-fade">
      <Modal v-if="showErrorModal">
        <div v-on-clickaway="returnRoute" class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt ly_alert">
            <div class="ly_inner">
              <p>
                {{ errorMessage }}
              </p>
              <div class="btnWrap">
                <button class="box_btn" @click="returnRoute">
                  <span class="an_t">확인</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
    <!-- ERROR MODAL END -->
  </div>
</template>

<script>
import Subbar from '@/components/library/Subbar'
import BookTable from '@/components/library/BookTable'
import TempPopup from '@/components/popup/TempPopup.vue'

import { mapGetters } from 'vuex'

import store from '@/store'

import {
  BOOKSHELF_GET_LIST,
  BOOKSHELF_SET_CURRENT,
  BOOKSHELF_BOOK_GET_LIST,
  UI_CLOSE_SIDEBAR,
  UI_SHOW_SIDEBAR
} from '@/store/types'

export default {
  name: 'Library',
  components: {
    Subbar,
    BookTable,
    TempPopup
  },
  data() {
    return {
      newListName: '',
      activeFilter: '',
      total: 0,
      currentPage: 1,
      showErrorModal: false
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentBookshelf',
      'getCurrentBookshelfBooks',
      'isBookshelfLoading',
      'getBookshelves',
      'isSidebarOpen',
      'getCurrentUser'
    ])
  },
  async beforeRouteEnter(to, from, next) {
    // if (!store.getters.getBookshelves.length && this.getCurrentUser) {
    //   await store.dispatch(BOOKSHELF_GET_LIST)
    // }
    if (to.params.id) {
      store.commit(BOOKSHELF_SET_CURRENT, to.params.id)
      next()
    } else {
      // const defaultBookshelf = store.getters.getBookshelves.find(
      //   (bs) => bs.isDefault
      // )
      // if (defaultBookshelf) {
      //   next({ name: 'library', params: { id: defaultBookshelf.id } })
      // }
      store.commit(BOOKSHELF_SET_CURRENT, '')
      next()
    }
  },
  async mounted() {
    if (this.getCurrentUser) {
      await this.$store.dispatch(BOOKSHELF_GET_LIST)
      await this.$store.dispatch(BOOKSHELF_BOOK_GET_LIST)
    } else {
      this.$router.push({
        name: 'login'
      })
    }
    /* 
      Currently we assume that library will contain first page worth
      of books and will be set on LIBRARY_SET_CURRENT mutation
    */

    this.$store.commit(UI_SHOW_SIDEBAR)
  },
  destroyed() {
    this.$store.commit(UI_CLOSE_SIDEBAR)
  },
  methods: {
    toggleErrorModal(errorMessage) {
      if (errorMessage) {
        this.errorMessage = errorMessage
      }
      this.showErrorModal = !this.showErrorModal
    },
    closeModal() {
      this.showErrorModal = false
    },
    returnRoute() {
      this.closeModal()
      this.$router.push({
        name: 'store'
      })
    },
    sortTable(sort) {
      this.$refs.booktable.paginate(1, sort)
    }
  }
}
</script>
<style lang="scss" scoped>
.aside_snb {
  width: calc(50vw - (var(--scrollbar-width) / 2) - 560px);
  min-width: 230px;
  max-width: 400px;
}
.sub_bar_custom,
.section {
  max-width: 1120px;
}
.section {
  background: #f0f5fa;
  width: 100%;
}
.ly_inner {
  p {
    text-align: center;
    padding-bottom: 24px;
  }
  .btnWrap {
    text-align: center;
  }
}
.box_btn.line {
  height: auto;
  padding: 8px 16px;
  // color: $h_BLUE_01;

  font-family: Noto Sans KR;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;

  letter-spacing: -0.03em;
}
@media (min-width: 1024px) {
  #container.grid-container {
    grid-template-columns: minmax(230px, calc(50vw - 560px)) 1fr;
    .section {
      justify-self: start;
      margin: 0;
    }
  }
  .sub_bar_custom {
    max-width: 1060px;
  }
}
</style>
